<template>
  <div class="test-route-container">
    <h1>路由测试页面</h1>
    <p>如果你能看到这个页面，说明路由配置工作正常。</p>
    <el-button type="primary" @click="goBack">返回</el-button>
  </div>
</template>

<script>
export default {
  name: 'TestRoute',
  created() {
},
  mounted() {
},
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.test-route-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}
</style> 